import { css } from "@emotion/css";

import { Accordion } from "../accordion/Accordion";
import { AccordionPanel } from "../accordion/AccordionPanel";
import { AccordionToggle } from "../accordion/AccordionToggle";
import { SectionSubHeading } from "../section-subheading/SectionSubHeading";

interface SectionProps {
  data: React.ReactNode;
  title: string;
  detailText?: string;
  isOpen?: boolean;
  testID?: string;
}

export function Section(props: SectionProps) {
  const { data, title, detailText, isOpen, testID } = props;
  return (
    <Accordion isOpen={isOpen}>
      {({ isOpen }) => (
        <div
          data-open={isOpen}
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: isOpen ? "var(--space-4)" : "0px",
            transition: "gap 0.2s ease-out",
          })}
        >
          <AccordionToggle
            className={css({
              // overflow: hidden - does not work here as the Icon inside requires focus which spills over
              borderRadius: "var(--border-radius-2)",
            })}
          >
            <SectionSubHeading
              title={title}
              detailText={detailText}
              isCollapsible
              isOpen={isOpen}
              testID={testID || null}
            />
          </AccordionToggle>
          <AccordionPanel>{data}</AccordionPanel>
        </div>
      )}
    </Accordion>
  );
}
